import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { Table, Card } from 'components/UI';
import Paginator from 'components/Paginator';
import i18n from 'i18n-js';
import moment from 'moment';
import Loading from 'components/Loading';
import { PricingActions } from 'state/modules/pricing';

const RulesetAssociatedVehileGroups = ({ id }) => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 5,
  });

  const { loading, rulesetVehicleGroups, rulesetVehicleGroupsPagination } = useSelector(
    (state) => state.pricing
  );
  const sharingType = useSelector(
    (state) => state.config?.settings?.core?.partnership?.sharing_type
  );

  useEffect(() => {
    if (id) {
      dispatch(PricingActions.fetchRulesetVehicleGroups(id, params));
    }
  }, [id, params]); // eslint-disable-line

  const handlePageChange = (event, page) => {
    const newParams = { page: page + 1, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  /**
   * Table columns
   */
  const columns = [
    {
      name: sharingType === 'FFB' ? i18n.t('common.fleet') : i18n.t('common.vehicle_group'),
      selector: 'name',
    },
    {
      name: i18n.t('common.start_date'),
      selector: (row) => (row?.start_time ? moment(row?.start_time).format('MMM DD, YYYY') : ''),
    },
    {
      name: i18n.t('common.end_date'),
      selector: (row) => (row?.end_time ? moment(row?.start_time).format('MMM DD, YYYY') : ''),
    },
  ];

  return (
    <Card
      headerActionType="vertical"
      data-cy="associated-groups-widget-card"
      title={
        sharingType === 'FFB' ? i18n.t('ruleset.associated_fleet') : i18n.t('ruleset.associated_vg')
      }
    >
      {loading ? (
        <Box justifyContent="center" alignItems="center" display="flex">
          <Loading />
        </Box>
      ) : (
        <>
          <Table
            data={rulesetVehicleGroups}
            columns={columns}
            pagination={false}
            paginationComponentOptions={{ noRowsPerPage: true }}
          />
          <Paginator
            component="div"
            limit={params.limit}
            rowsPerPageOptions={[5]}
            pagination={rulesetVehicleGroupsPagination}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </Card>
  );
};

export default RulesetAssociatedVehileGroups;
